











































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import ButtonResults from 'components/presenter/item/topic/viewer/ButtonResults.vue'

@Component({
  components: {
    MarkdownViewerCrdt,
    ButtonResults
  }
})
export default class ItemTopicViewerRate extends Vue {
  response: number | null = null
  statistics: number[] = new Array(11).fill(0)

  @Prop({ default: false })
  readonly feedbackButtonShow!: boolean

  @Prop({ default: false })
  readonly feedbackButtonOn!: boolean

  @Prop()
  readonly slide!: Json

  @Prop({ default: null })
  readonly stats!: Json | null

  @Prop({ default: false })
  readonly readonly!: boolean

  @Prop()
  readonly value!: number | undefined

  @Watch('value', { immediate: true })
  update (value: number | undefined) {
    if (this.slide.range === 'slider100') {
      this.response = isNaN(value as number) || value === undefined || value === null ? null : value
    } else if (this.slide.range === 'scale1to10') {
      this.response = isNaN(value as number) || value === undefined || value === null ? null : Math.max(1, Math.ceil( value / 10 ))
    } else if (this.slide.range === 'scale0to10') {
      this.response = isNaN(value as number) || value === undefined || value === null ? null : Math.ceil( value / 10 )
    } else {
      this.response = isNaN(value as number) || value === undefined || value === null ? null : Math.max(1, Math.ceil( value / 20 ))
    }
  }

  get text () {
    return this.slide?.text?.getText()
  }

  get size () {
    return this.$q.screen.lt.sm ? '12px' : (this.$q.screen.lt.md ? 'md' : 'lg')
  }

  @Watch('stats', { immediate: true, deep: true })
  createStatistics (stats: Json | undefined) {
    const statistics = new Array(11).fill(0)
    if (stats) {
      const ntotal = Object.values(stats).reduce((n: number, count: number) => {
        return n + (count || 0)
      }, 0)
      for (const value in stats) {
        const index = Math.ceil((+value) / 10)
        statistics[ index ] += stats[ value ]
      }
      this.statistics = statistics.map(n => n / Math.max(1, ntotal))
    } else {
      this.statistics = statistics
    }
    switch (this.slide.range) {
      case 'scale0to10':
        break
      case 'slider100':
      case 'scale1to10':
        this.statistics[1] += this.statistics[0]
        break
      default:
        this.statistics[2] += this.statistics[1] + this.statistics[0]
        this.statistics[4] += this.statistics[3]
        this.statistics[6] += this.statistics[5]
        this.statistics[8] += this.statistics[7]
        this.statistics[10] += this.statistics[9]
        break
    }
  }

  respond (value: number) {
    if (!this.readonly) {
      let response: number | undefined
      if (this.slide.range === 'slider100') {
        response = isNaN(value as number) || value === this.response ? undefined : value
      } else if (this.slide.range === 'scale1to10') {
        response = isNaN(value as number) || value === this.response ? undefined : value * 10
      } else if (this.slide.range === 'scale0to10') {
        response = isNaN(value as number) || value === this.response ? undefined : value * 10
      } else {
        response = value === 0 ? undefined : value * 20
      }
      this.update(response)
      this.$emit('input', response)
    }
  }
}
